<div class="card">
  <p-breadcrumb 
    class="w-full breadcrumb-style" 
    [home]="breadcrumbHome"/>

  <div class="body-card py-3 px-4">
    <div class="header-card pt-0 mb-4">
      <div class="w-12 container-title">
        <h1 class="text-xl font-medium text-800 m-0">
          {{'UserPages.UserPanel.PageTitle' | translate}}
        </h1>
        <span class="text-800">{{'UserPages.UserPanel.PageDescriptionText' | translate}}</span>
      </div>
    </div>

    <div *ngIf="user && user?.profileType == 'Exporter'" class="custom-tabview">
      <p-tabView [(activeIndex)]="indexTab">
        <p-tabPanel header="{{'UserPages.UserPanel.Tabs.ProfileTabTitle' | translate}}">
          <app-contact-info-tab/>
        </p-tabPanel>
        <p-tabPanel header="{{'UserPages.UserPanel.Tabs.CompanyTabTitle' | translate}}">
          <app-company-info-tab/>
        </p-tabPanel>
        <p-tabPanel header="{{'UserPages.UserPanel.Tabs.SpeciesTabTitle' | translate}}">
          <app-species-list/>
        </p-tabPanel>
        <p-tabPanel header="{{'UserPages.UserPanel.Tabs.ColdStoragesTabTitle' | translate}}">
          <app-cold-storages/>
        </p-tabPanel>
        <p-tabPanel header="{{'UserPages.UserPanel.Tabs.ProductsCertificatesTabTitle' | translate}}">
          <app-product-certificates-tab/>
        </p-tabPanel>
        <p-tabPanel header="{{'UserPages.UserPanel.Tabs.SecurityTabTitle' | translate}}">
          <app-security-tab/>
        </p-tabPanel>
      </p-tabView>
    </div>
    
    <div *ngIf="user && user?.profileType != 'Exporter'" class="grid">
      <div class="col-4">
        <div class="option-card">
          <div class="container-subcard">
            <h2 class="title-card">{{'UserPages.UserPanel.ContactInfoLabel' | translate}}</h2>
            <i class="pi pi-user-edit" style="font-size: 5rem; color: #682172;"></i>
            <p-button label="{{'UserPages.UserPanel.EditButtonLabel' | translate}}" icon="pi pi-pencil" [style]="{'margin-top': '20px'}" (onClick)="goToContactInfoPage()"></p-button>
          </div>
        </div>
      </div>
      <div class="col-4" *ngIf="user.profileType != 'Admin'">
        <div class="option-card">
          <div class="container-subcard">
            <h2 class="title-card">{{'UserPages.UserPanel.CompanyInfoLabel' | translate}}</h2>
            <i class="pi pi-sitemap" style="font-size: 5rem; color: #682172;"></i>
            <p-button label="{{'UserPages.UserPanel.EditButtonLabel' | translate}}" icon="pi pi-pencil" [style]="{'margin-top': '20px'}" (onClick)="goToCompanyInfoPage()"></p-button>
          </div>
        </div>
      </div>
      <div class="col-4" *ngIf="user.profileType == 'Importer'">
        <div class="option-card">
          <div class="container-subcard">
            <h2 class="title-card">{{'UserPages.UserPanel.ConsigneeLabel' | translate}}</h2>
            <i class="pi pi-users" style="font-size: 5rem; color: #682172;"></i>
            <p-button label="{{'UserPages.UserPanel.EditButtonLabel' | translate}}" icon="pi pi-pencil" [style]="{'margin-top': '20px'}" (onClick)="goToConsigneesPage()"></p-button>
          </div>
        </div>
      </div>
      <div class="col-4" *ngIf="user.profileType == 'Importer'">
        <div class="option-card">
          <div class="container-subcard">
            <h2 class="title-card">{{'UserPages.UserPanel.NotifyLabel' | translate}}</h2>
            <i class="pi pi-users" style="font-size: 5rem; color: #682172;"></i>
            <p-button label="{{'UserPages.UserPanel.EditButtonLabel' | translate}}" icon="pi pi-pencil" [style]="{'margin-top': '20px'}" (onClick)="goToNotifiesPage()"></p-button>
          </div>
        </div>
      </div>
      <div class="col-4" *ngIf="user.profileType == 'Importer'">
        <div class="option-card">
          <div class="container-subcard">
            <h2 class="title-card">{{'UserPages.UserPanel.FavoriteSpeciesLabel' | translate}}</h2>
            <span class="material-symbols-outlined" style="font-size: 5rem; color: #682172;">nutrition</span>
            <p-button label="{{'UserPages.UserPanel.EditButtonLabel' | translate}}" icon="pi pi-pencil" [style]="{'margin-top': '20px'}" (onClick)="goToUserProducts()"></p-button>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="option-card">
          <div class="container-subcard">
            <h2 class="title-card">{{'UserPages.UserPanel.SecuritySettings' | translate}}</h2>
            <i class="pi pi-lock" style="font-size: 5rem; color: #682172;"></i>
            <p-button label="{{'UserPages.UserPanel.EditButtonLabel' | translate}}" icon="pi pi-pencil" [style]="{'margin-top': '20px'}" (onClick)="goToSecurityOptions()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>